<template>
<transition name="slide-fade">
<div class="menu">
	<ul>
		<li v-if="!search">
			<el-button type="button" @click='changeinfo'>{{$t('menu.changeinfo')}}</el-button></li>
		<li>
		<li v-if="search">
			<el-button type="button" @click='changeinfopublish'>{{$t('menu.changeinfo')}}</el-button></li>
		<li>
			<el-button type="button" @click='mytag'>{{$t('menu.mytag')}}</el-button>
		</li>
		<li>
			<el-button type="button" @click='scanningrecord'>{{$t('menu.scanningrecord')}}</el-button>
		</li>
	</ul>
</div>
</transition>	
</template>
<script>
import axios from "axios";
import Qs from "qs";
import bridge from"../../store/bus.js";
import { getDevices,getDevicesInfo} from "../../deviceApi/index.js";
export default{
	name:'menus',
	data(){
		return{
			info:{
            menuC:'',
            cords:'',
            lostpetinfos:'',
            lostsign:'',
            ifedit:'',
            isable:'',
            lossbtn:'',
            editimg:'',
            showimg:'',
            addtext:'',
            activations:'',
       		},
       		search:false,
		}
	},
	mounted(){
		let search = localStorage.search;
		if(search=='true'){
			this.search = true;
		}else{
			this.search = false;
		}
	},
	created(){

	},
	watch:{
		
	},
	methods: {
		changeinfo(){
			this.info.menuC = false;
			this.info.ifedit = true;//宠物信息编辑打开
			this.info.isable = false;//主人信息编辑打开
			this.info.activations = true;
			this.info.lossbtn = false;//发布丢失按钮打开
			this.$emit("menuC",this.info);
			this.$emit("editmyinfo",this.info)
		},
		changeinfopublish(){
			this.info.menuC = false;
			this.info.lostpetinfos = true;//编辑宠物组件显示
			this.info.lostsign = true;//走失标志显示
			this.info.ifedit = true;//宠物信息编辑打开
			this.info.isable = false;//主人信息编辑打开
			this.info.lossbtn = false;//发布丢失按钮打开
			this.info.editimg = true;
			this.info.showimg = false;
			this.info.addtext =true;
			this.$emit("menuC",this.info);
			this.$emit("editinfos",this.info)
			bridge.$emit("editinfos",this.info);
		},
		mytag(){
			this.info.menuC = false;
			this.$emit("menuC",this.info);
			this.$router.push('/mytag?accessToken='+localStorage.token+'&deviceCode='+localStorage.codeId)
		},
		scanningrecord(){
			this.info.menuC = false;
			this.info.cords = true;
			this.$emit("menuC",this.info);
		},

	}
}
	
	
</script>

<style>
.menu{
	width: 100%;
	height: 100%;
	position: fixed;
	top: 0;
	z-index: 998;
	overflow: auto;
	background: rgba(0,0,0,.6);
}
.menu ul {
	width: 100%;
	position: relative;
	top: 55%;
	margin: 0 auto;
}
.slide-fade-enter-active {
  transition: all .3s ease;
}
.slide-fade-leave-active {
  transition: all .5s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active 用于 2.1.8 以下版本 */ {
  transform: translateX(10px);
  opacity: 0;
}
.menu ul li .el-button--button { /*激活按钮*/
	display: block;
    width: 70%;
    margin: 15px auto;
    font-size: 1rem;
    height: 2.5rem;
    line-height: 2.5rem;
    color: rgb(255,255,255);
    border-radius: 1.3rem;
    background-image: linear-gradient(to right , #65d3e8, #7dc3f2);
    border: 0;
    padding: 0 0;
}	
</style>


// WEBPACK FOOTER //
// src/m_page/home/menus.vue